<template>
    <div class="legal-landing">
        <h1>{{trans.get('legal.privacypolicy.title')}}</h1>
        <div>
            <p v-html="trans.get('legal.privacypolicy.text1')"></p>
            <p><strong>{{trans.get('legal.privacypolicy.text2')}}</strong></p>
            <p>{{trans.get('legal.privacypolicy.text3')}}</p>
            <ul>
                <li>{{trans.get('legal.privacypolicy.ul1.li1')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul1.li2')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul1.li3')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul1.li4')}}</li>
            </ul>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle2')}}</strong></p>
            <p>{{trans.get('legal.privacypolicy.text4')}}</p>
            <ul>
               <li v-html="trans.get('legal.privacypolicy.ul2.li1')"></li>
                <li v-html="trans.get('legal.privacypolicy.ul2.li2')"></li>
                <li>{{trans.get('legal.privacypolicy.ul2.li3')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul2.li4')}}</li>
                <li v-html="trans.get('legal.privacypolicy.ul2.li5')"></li>
                <li v-html="trans.get('legal.privacypolicy.ul2.li6')"></li>
            </ul>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle3')}}</strong></p>
            <p>{{trans.get('legal.privacypolicy.text5')}}</p>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle4')}}</strong></p>
            <p v-html="trans.get('legal.privacypolicy.text6')"></p>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle5')}}</strong></p>
            <p>{{trans.get('legal.privacypolicy.text7')}}</p>
            <ul>
                <li>{{trans.get('legal.privacypolicy.ul3.li1')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul3.li2')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul3.li3')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul3.li4')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul3.li5')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul3.li6')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul3.li7')}}</li>

            </ul>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle6')}}</strong></p>
            <p v-html="trans.get('legal.privacypolicy.text8')"></p>
            <p>
                <strong
                    >{{trans.get('legal.privacypolicy.subtitle7')}}</strong
                >
            </p>
            <p v-html="trans.get('legal.privacypolicy.text9')"></p>
            <p>{{trans.get('legal.privacypolicy.text10')}}</p>
            <p>{{trans.get('legal.privacypolicy.text11')}}</p>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle8')}}</strong></p>
            <p v-html="trans.get('legal.privacypolicy.text12')"></p>
            <p v-html="trans.get('legal.privacypolicy.text13')"></p>
            <p>{{trans.get('legal.privacypolicy.text14')}}</p>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle9')}}</strong></p>
            <p>{{trans.get('legal.privacypolicy.text15')}}</p>
            <p>{{trans.get('legal.privacypolicy.text16')}}</p>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle10')}}</strong></p>
            <p>{{trans.get('legal.privacypolicy.text17')}}</p>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle11')}}</strong></p>
            <p v-html="trans.get('legal.privacypolicy.text18')"></p>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle12')}}</strong></p>
            <p v-html="trans.get('legal.privacypolicy.text19')"></p>
            <p>{{trans.get('legal.privacypolicy.text20')}} </p>
            <p v-html="trans.get('legal.privacypolicy.text21')"></p>
            <p>{{trans.get('legal.privacypolicy.text22')}}</p>

            <p><strong>{{trans.get('legal.privacypolicy.subtitle13')}}</strong></p>
            <p v-html="trans.get('legal.privacypolicy.text23')"></p>
            <ul>
                <li v-html="trans.get('legal.privacypolicy.ul4.li1')"></li>
                <li>{{trans.get('legal.privacypolicy.ul4.li2')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul4.li3')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul4.li4')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul4.li5')}}</li>
                <li v-html="trans.get('legal.privacypolicy.ul4.li6')"></li>
                <li>{{trans.get('legal.privacypolicy.ul4.li7')}}</li>
            </ul>
            <p>{{trans.get('legal.privacypolicy.text24')}}</p>
            <ul>
                <li>{{trans.get('legal.privacypolicy.ul5.li1')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul5.li2')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul5.li3')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul5.li4')}}</li>
                <li>{{trans.get('legal.privacypolicy.ul5.li5')}}</li>

            </ul>
            <p>{{trans.get('legal.privacypolicy.text25')}}
            </p>
            <p><strong>{{trans.get('legal.privacypolicy.subtitle14')}}</strong></p>
            <p v-html="trans.get('legal.privacypolicy.text26')"></p>
            <p>
                <strong>{{trans.get('legal.privacypolicy.subtitle15')}}</strong>
            </p>
            <p>{{trans.get('legal.privacypolicy.text27')}}</p>
            <p>&nbsp;</p>
            <p>
                <strong>{{trans.get('legal.privacypolicy.subtitle16')}}</strong>
            </p>
            <p>{{trans.get('legal.privacypolicy.text28')}}</p>
            <p>{{trans.get('legal.privacypolicy.text20')}}</p>
            <p>{{trans.get('legal.privacypolicy.text30')}}</p>
        </div>
        <!-- .fl-post-content -->
    </div>
</template>

<script>
export default {};
</script>
